import getPageType from './get-page-type';
export default function sendToThdCanada(eventType, payload) {
  const pageType = getPageType(); // eslint-disable-next-line

  console.log(`Canada Analytics: ${eventType}`, {
    eventType,
    payload,
    pageType
  });

  if (window.sendDataToEVT) {
    window.sendDataToEVT(eventType, payload, pageType);
  } else {
    // eslint-disable-next-line
    console.log('window.sendDataToEvt not found.');
  }
}